// Inspired by https://thelig.ht/chladni/

const chladniFragmentShader = `
in vec2 vUv;
uniform vec4 chladniParametersA;
uniform vec4 chladniParametersB;
uniform float slice;

uniform float thickness;

float sampleDigital(vec2 inP) {
	vec2 p = inP * 2. - 1.;

	vec4 current = mix(chladniParametersB, chladniParametersA, slice);

	float a = current.x;
	float n = current.y;
	float m = current.z;
	float b = current.a;
			
	float max_amp = abs(a) + abs(b);
	float amp = a * sin(PI*n*p.x) * sin(PI*m*p.y) + b * sin(PI*m*p.x) * sin(PI*n*p.y);

	// float col = step(abs(amp), mix(.3, 1.3, abs(thickness - .5) * 2.));
	float col = step(abs(amp), abs(thickness));

	// if (thickness < 0.) {
	// 	col = 1. - col;
	// }
	return col;
}

void main(){
	csm_DiffuseColor = vec4(vec3(sampleDigital(vUv)), 1.0);
}
`

export default chladniFragmentShader
